export default "__VITE_ASSET__D3Fle5TS__"